module.exports = __webpack_public_path__ + "public/img/guanjun.c54bcfd6.png";